export const style = {
  label: {
    sx: {
      color: '#130F35',
    },
  },
  Box: {
    sx: {
      display: 'flex',
      gap: 3,
      pt: 2,
      '& .MuiFormControl-root': {
        flex: 1,
      },
    },
  },
} as const;
